// import MainView from "@/views/main/MainView.vue";
import BotView from "@/views/bot/BotView.vue";
import GridBot from "@/components/bot/grid/GridBot.vue";
import PositionBot from "@/components/bot/ManageBot.vue";
import Trading from "@/components/trading/index.vue";
// import ChartView from "@/views/chart/ChartView.vue";
import MetahChartView from "@/views/chart/MetaChartView.vue";
import DominanceChartView from "@/views/chart/DominanceChartView.vue";
import ScoreChartView from "@/views/chart/ScoreChartView.vue";
import ScoreListView from "@/views/chart/ScoreListView.vue";
import TradingviewView from "@/views/chart/TradingviewView.vue";
import Chart from "@/views/chart/chart.vue";
import Chart2 from "@/views/chart/chart2.vue";
import Popup from "@/pages/kibot/popup/PopUp.vue";
import ChartCapture from "@/views/capture/chartCapture.vue";
import DashboardView from "@/views/chart/DashboardView.vue";
import ExplorerView from "@/views/chart/ExplorerView.vue";
import KibotZoneListView from "@/views/chart/KibotZoneListView.vue";
import CrossListView from "@/views/chart/CrossListView.vue";
import DoubleListView from "@/views/chart/DoubleListView.vue";
import FavoritesView from "@/views/chart/FavoritesView.vue";

const currentEnv = process.env.NODE_ENV;
const routes = [
  // {
  //     path:'/',
  //     redirect:'/kibot/chart2?menuName=coin_list'
  // },
  // {
  //   path: "/kibot/bot",
  //   component: BotView,
  //   redirect: "/kibot/bot/position",
  //   children: [
  //     { path: "position", component: PositionBot },
  //     // { path: "grid", component: GridBot },
  //   ],
  // },
  {
    path: "/edit-kibot",
    component: BotView,
  },
  {
    path: "/kibot/chart",
    component: Chart,
    props: (route) => ({
      currentStrategy: route.query.currentStrategy,
    }),
  },
  {
    path: "/kibot/chart2",
    component: Chart2,
  },
  {
    path: "/kibot/dashboard",
    component: DashboardView,
  },
  {
    path: "/kibot/explorer",
    component: ExplorerView,
  },
  {
    path: "/kibot/kibot-zone-list",
    component: KibotZoneListView,
  },
  {
    path: "/kibot/cross-list",
    component: CrossListView,
  },
  {
    path: "/kibot/double-list",
    component: DoubleListView,
  },
  {
    path: "/kibot/favorites",
    component: FavoritesView,
  },
  {
    path: "/meta-chart",
    component: MetahChartView,
  },
  {
    path: "/dominance-chart",
    component: DominanceChartView,
  },
  {
    path: "/score-chart",
    component: ScoreChartView,
  },
  {
    path: "/score-list",
    component: ScoreListView,
  },
  {
    path: "/trading-view",
    component: TradingviewView,
  },
  {
    path: "/popup",
    component: Popup,
    meta: { isPopup: true }, // 팝업임을 표시
  },
  {
    path: "/capture",
    component: ChartCapture,
  },
  {
    path: "/trading",
    component: Trading,
  },

  // {
  //     path:"/news/:category",
  //     component:NewsView,
  // },
  // {
  //     path:"/news/post/:id",
  //     component:NewsDetailView
  // },
  // {
  //     path:"/market",
  //     component:MarketView
  // },
  // {
  //     path:"/chart",
  //     component:ChartView,
  //     // beforeEnter: (to,from,next) => {
  //     //     console.log('from',from);
  //     //     let symbol = to.query.symbol;
  //     //     console.log('symbol',symbol);
  //     //     if(store.state.exchangeInfo.symbolList.includes(symbol) ){
  //     //         next()
  //     //     }else if(symbol == undefined){
  //     //         // alert('Symbol not found.')
  //     //         // next(false)
  //     //     }
  //     // }
  // },
  // {
  //     path: "/404",
  //     component: NotFound
  // },
  // {
  //     path: '/:pathMatch(.*)*',
  //     redirect: "/404",
  // },
  {
    path: "/:pathMatch(.*)*",
    redirect: (to) => {
      if (to.fullPath.startsWith("/kibot/bot")) {
        return "/kibot/dashboard";
      } 
      // 현재 경로가 이미 올바른 경로이면 리다이렉트하지 않음
      if (to.fullPath.startsWith("/kibot") && to.query.menuName) {
        return to.fullPath; // 현재 경로 유지
      }
      return "/kibot/dashboard"; // 기본 경로로 리다이렉트
    },
  },
];

export default routes;
